//Generated File 
export const Failed = `Failed`;
export const FailedByException = `FailedByException`;
export const Initial = `Initial`;
export const Processed = `Processed`;
export const Processing = `Processing`;
export const Retry = `Retry`;
